<script lang="ts">
export default {
  name: 'KkFilterButton',
}
</script>

<script setup lang="ts">
import { KkIcon } from '../../base'

interface Props {
  disabled?: boolean;
}

interface Emits {
  (key: 'click', event: MouseEvent): void
}

const emits = defineEmits<Emits>()
const onClick = ($event: MouseEvent) => {
  emits('click', $event)
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})
</script>

<template>
  <div class="p-filtersA">
    <div class="p-filtersA__left">
      <button :disabled="props.disabled" class="c-buttonFilter" :class="{'disabled': props.disabled}" @click="onClick">
        {{ $t('pages.CompaniesStorePost.filters') }}
        <div class="c-buttonFilter__icon">
          <KkIcon name="filter" />
        </div>
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .disabled {
    cursor: not-allowed;
  }
</style>
